<app-user-detail
  *ngIf="userType !== 'USER'"
  [userUuid]="userToBook"
  (navigateEvent)="goBack()"
></app-user-detail>

<div class="container">
  <span class="component-info heading-5">{{
    "hotel.custom.lets-request" | translate
  }}</span>

  <div class="bg-card">
    <div class="service-card-container">
      <div class="selector">
        <span class="selector-item-selected" *ngIf="canRequestCustomBooking || isAdmin">{{
          "common.hotels" | translate
        }}</span>
        <span
          class="selector-item"
          (click)="navigate('flight')"
          *ngIf="canRequestCustomFlight || isAdmin"
          >{{ "common.flights" | translate }}</span
        >
        <span
          class="selector-item"
          (click)="navigate('train')"
          *ngIf="canRequestCustomTrain || isAdmin"
          >{{ "common.trains" | translate }}</span
        >
        <span
          class="selector-item"
          (click)="navigate('car')"
          *ngIf="canRequestCustomCar || isAdmin"
          >{{ "common.cars" | translate }}</span
        >
        <span
          class="selector-item"
          *ngIf="canRequestCustomAirbnb || isAdmin"
          (click)="navigate('airbnb')"
          >{{ "airbnb.custom.request.option" | translate }}</span
        >
      </div>

      <form class="custom-hotel-form"
        [formGroup]="form"
        [ngClass]="{ 'loading-background': loading }"
        (ngSubmit)="form.valid && !loading ? onSubmit() : (isInvalid = true)"
      >
        <div class="row" *ngIf="isModal && !userUuid">
          <div class="col-12">
            <div class="form-group">
              <mat-label
                >{{
                  type + ".create-" + type + ".choose-employee" | translate
                }}*</mat-label
              >
              <select
                class="form-control rounded-1 w-25"
                formControlName="userUuid"
              >
                <option
                  *ngFor="
                    let user of users;
                    trackBy: utilsService.getUuidTracking
                  "
                  [ngValue]="user"
                >
                  {{ user.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="custom-col-size">
            <input
            formControlName="city"
            type="text"
            id="destination"
            class="ubication-input form-control form-control--no-border"
            matInput
            [matAutocomplete]="city"
            (input)="getCities($event.target.value)"
            [ngClass]="{
              'input-error': !form.controls.city.valid && isInvalid
            }"
            placeholder="{{ 'hotel.custom.city' | translate }}"
          />
          <mat-autocomplete
            #city="matAutocomplete"
            panelWidth="20%"
            (optionSelected)="cleanCitiesList($event.option.value)"
          >
            <mat-option *ngFor="let option of citiesList" [value]="option">
              {{ option }}
            </mat-option>
          </mat-autocomplete>
          </div>
          <div class="custom-col-size">
            <input
            formControlName="hotel"
            [matAutocomplete]="hotel"
            (input)="getHotels($event.target.value)"
            type="text"
            id="origin"
            class="hotel-name form-control form-control--no-border"
            [ngClass]="{
              'input-error': !form.controls.hotel.valid && isInvalid
            }"
            placeholder="{{ 'hotel.custom.hotel-name' | translate }}"
          />
          <mat-autocomplete
            #hotel="matAutocomplete"
            panelWidth="20%"
            (optionSelected)="cleanHotelsList()"
          >
            <mat-option *ngFor="let option of hotelsList" [value]="option">
              {{ option }}
            </mat-option>
          </mat-autocomplete>
          </div>
        </div>
        <div class="form-row">
          <div
            class="custom-col-size hotel-date-field form-control form-control--no-border"
            [formGroup]="form"
            [ngClass]="{
              'input-error':
                (!form.controls.checkIn.valid ||
                  !form.controls.checkOut.valid) &&
                isInvalid
            }"
          >
            <input
              #bookedRange
              class="date-input"
              style="padding-left: 1rem;"
              (dateSelect)="onDateSelection($event)"
              placeholder="{{ 'hotel.custom.select-date' | translate }}"
              #dp
              ngbDatepicker
              [dayTemplate]="t1"
              [autoClose]="'outside'"
              [displayMonths]="1"
              #d1="ngbDatepicker"
              readonly
              (click)="d1.toggle()"
              (closed)="onDatepickerClosed()"
              [minDate]="minDateNgStruct"
              [maxDate]="maxDateNgStruct"
            />
            <ng-template #t1 let-date let-focused="focused">
              <span
                class="custom-day"
                [ngClass]="{
                  activeFrom: form.controls['checkIn'].value === date,
                  activeTo: form.controls['checkOut'].value === date
                }"
                [class.focused]="focused"
                [class.range]="isRange(date)"
                [class.faded]="isHovered(date) || isInside(date)"
                (mouseenter)="hoveredDate = date"
                (mouseleave)="hoveredDate = null"
              >
                {{ date.day }}
              </span>
            </ng-template>
          </div>

          <div class="custom-col-size hotel-rooms-field">
            <input
              type="number"
              min="1"
              max="99"
              formControlName="rooms"
              class="rooms-input"
              style="margin-left: 1rem;"
            />
            <span>{{ "hotel.custom.rooms" | translate }}</span>
          </div>
        </div>

        <div *ngIf="defaultUser" class="travelers-rooms-grid">
          <div class="traveler-room-card">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>{{ "hotel.people-per-room" | translate }} 1</mat-label>
              <mat-select
                [formControl]="getRoomTravelerControl(0)"
                multiple
                [compareWith]="compareUsers"
                (closed)="clearSearch(0)"
              >
                <mat-select-trigger>
                  <span *ngIf="!getRoomTravelerControl(0)?.value?.length">
                    {{ "hotel.select-travelers" | translate }}
                  </span>

                  <span *ngIf="getRoomTravelerControl(0)?.value?.length">
                    {{ getRoomTravelerNames(0) }}
                  </span>
                </mat-select-trigger>

                <mat-option>
                  <input
                    class="custom-mat-input"
                    #input
                    matInput
                    (input)="applyFilter($event.target.value)"
                    (click)="$event.stopPropagation()"
                    placeholder="{{ 'common.search-user' | translate }}"
                  />
                </mat-option>

                <mat-option
                  *ngFor="let externalTraveler of getRoomExternalTravelers(0)"
                  [value]="externalTraveler"
                >
                  {{ externalTraveler.name }} {{ externalTraveler.lastname }}
                  - {{ 'hotel.external-guest.label' | translate }}
                </mat-option>

                <mat-option [value]="defaultUser" [disabled]="true">
                  {{ defaultUser.name }} {{ defaultUser.lastname }}
                </mat-option>

                <mat-option *ngFor="let user of filteredUsersWithoutDefault" [value]="user">
                  {{ user.name }} {{ user.lastname }}
                </mat-option>
              </mat-select>
            </mat-form-field>


            <div class="custom-room-external-guest">
              <button
                type="button"
                class="external-guest-toggle"
                (click)="toggleExternalGuestFormForRoom(0)"
              >
                <span>{{ 'hotel.external-guest.label' | translate }}</span>
                <span
                  class="external-guest-select-arrow"
                  [ngClass]="{ 'opened': externalGuestModeByRoom[0] }"
                ></span>
              </button>

              <div
                class="external-guest-panel"
                *ngIf="externalGuestModeByRoom[0]"
                (click)="$event.stopPropagation()"
              >
                <div class="external-guest-inputs">
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="externalGuestNameByRoom[0]"
                    [ngModelOptions]="{ standalone: true }"
                    [placeholder]="'hotel.external-guest.name-placeholder' | translate"
                    (keydown.enter)="addExternalGuestForRoom(0); $event.preventDefault()"
                  />

                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="externalGuestLastnameByRoom[0]"
                    [ngModelOptions]="{ standalone: true }"
                    [placeholder]="'hotel.external-guest.lastname-placeholder' | translate"
                    (keydown.enter)="addExternalGuestForRoom(0); $event.preventDefault()"
                  />
                </div>

                <div class="external-guest-actions">
                  <button
                    type="button"
                    class="external-guest-add"
                    [disabled]="!externalGuestNameByRoom[0]?.trim() || !externalGuestLastnameByRoom[0]?.trim()"
                    [ngClass]="{
                      'disabled-button': !externalGuestNameByRoom[0]?.trim() || !externalGuestLastnameByRoom[0]?.trim()
                    }"
                    (click)="addExternalGuestForRoom(0)"
                  >
                    {{ 'common.add' | translate }}
                  </button>

                  <button
                    type="button"
                    class="external-guest-cancel"
                    (click)="cancelExternalGuestForRoom(0)"
                  >
                    {{ 'common.cancel' | translate }}
                  </button>
                </div>
              </div>
            </div>

            <div
              class="external-guests-edit room-external-guests-edit"
              *ngIf="getRoomExternalTravelers(0).length > 0"
            >
              <div
                class="external-guest-row"
                *ngFor="
                  let externalTraveler of getRoomExternalTravelers(0);
                  let externalIndex = index;
                  trackBy: trackByTravelerUuid
                "
              >
                <label>
                  {{ 'hotel.external-guest.label' | translate }} {{ externalIndex + 1 }}
                </label>

                <input
                  class="form-control"
                  type="text"
                  [value]="externalTraveler.name"
                  [placeholder]="'common.name' | translate"
                  (input)="changeRoomExternalTravelerName(0, externalTraveler.uuid, 'name', $event.target.value)"
                />

                <input
                  class="form-control"
                  type="text"
                  [value]="externalTraveler.lastname"
                  [placeholder]="'user.form.surname' | translate"
                  (input)="changeRoomExternalTravelerName(0, externalTraveler.uuid, 'lastname', $event.target.value)"
                />
              </div>
            </div>
          </div>

          <div
            class="traveler-room-card"
            *ngFor="let travelersControl of getTravelersPerRoom.controls; let i = index"
          >
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>{{ "hotel.people-per-room" | translate }} {{ i + 2 }}</mat-label>
                <mat-select
                  [formControl]="travelersControl"
                  multiple
                  [compareWith]="compareUsers"
                  (closed)="clearSearch(i + 1)"
                >
                  <mat-select-trigger>
                    <span *ngIf="!getRoomTravelerControl(i + 1)?.value?.length">
                      {{ "hotel.select-travelers" | translate }}
                    </span>

                    <span *ngIf="getRoomTravelerControl(i + 1)?.value?.length">
                      {{ getRoomTravelerNames(i + 1) }}
                    </span>
                  </mat-select-trigger>

                  <mat-option>
                    <input
                      class="custom-mat-input"
                      #input
                      matInput
                      (input)="applyFilter($event.target.value)"
                      (click)="$event.stopPropagation()"
                      placeholder="{{ 'common.search-user' | translate }}"
                    />
                  </mat-option>

                  <mat-option
                    *ngFor="let externalTraveler of getRoomExternalTravelers(i + 1)"
                    [value]="externalTraveler"
                  >
                    {{ externalTraveler.name }} {{ externalTraveler.lastname }}
                    - {{ 'hotel.external-guest.label' | translate }}
                  </mat-option>

                  <mat-option *ngFor="let user of filteredUsers" [value]="user">
                    {{ user.name }} {{ user.lastname }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <div class="custom-room-external-guest">
                <button
                  type="button"
                  class="external-guest-toggle"
                  (click)="toggleExternalGuestFormForRoom(i + 1)"
                >
                  <span>{{ 'hotel.external-guest.label' | translate }}</span>
                  <span
                    class="external-guest-select-arrow"
                    [ngClass]="{ 'opened': externalGuestModeByRoom[i + 1] }"
                  ></span>
                </button>

                <div
                  class="external-guest-panel"
                  *ngIf="externalGuestModeByRoom[i + 1]"
                  (click)="$event.stopPropagation()"
                >
                  <div class="external-guest-inputs">
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="externalGuestNameByRoom[i + 1]"
                      [ngModelOptions]="{ standalone: true }"
                      [placeholder]="'hotel.external-guest.name-placeholder' | translate"
                      (keydown.enter)="addExternalGuestForRoom(i + 1); $event.preventDefault()"
                    />

                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="externalGuestLastnameByRoom[i + 1]"
                      [ngModelOptions]="{ standalone: true }"
                      [placeholder]="'hotel.external-guest.lastname-placeholder' | translate"
                      (keydown.enter)="addExternalGuestForRoom(i + 1); $event.preventDefault()"
                    />
                  </div>

                  <div class="external-guest-actions">
                    <button
                      type="button"
                      class="external-guest-add"
                      [disabled]="!externalGuestNameByRoom[i + 1]?.trim() || !externalGuestLastnameByRoom[i + 1]?.trim()"
                      [ngClass]="{
                        'disabled-button': !externalGuestNameByRoom[i + 1]?.trim() || !externalGuestLastnameByRoom[i + 1]?.trim()
                      }"
                      (click)="addExternalGuestForRoom(i + 1)"
                    >
                      {{ 'common.add' | translate }}
                    </button>

                    <button
                      type="button"
                      class="external-guest-cancel"
                      (click)="cancelExternalGuestForRoom(i + 1)"
                    >
                      {{ 'common.cancel' | translate }}
                    </button>
                  </div>
                </div>
              </div>

              <div
                class="external-guests-edit room-external-guests-edit"
                *ngIf="getRoomExternalTravelers(i + 1).length > 0"
              >
                <div
                  class="external-guest-row"
                  *ngFor="
                    let externalTraveler of getRoomExternalTravelers(i + 1);
                    let externalIndex = index;
                    trackBy: trackByTravelerUuid
                  "
                >
                  <label>
                    {{ 'hotel.external-guest.label' | translate }} {{ externalIndex + 1 }}
                  </label>

                  <input
                    class="form-control"
                    type="text"
                    [value]="externalTraveler.name"
                    [placeholder]="'common.name' | translate"
                    (input)="changeRoomExternalTravelerName(i + 1, externalTraveler.uuid, 'name', $event.target.value)"
                  />

                  <input
                    class="form-control"
                    type="text"
                    [value]="externalTraveler.lastname"
                    [placeholder]="'user.form.surname' | translate"
                    (input)="changeRoomExternalTravelerName(i + 1, externalTraveler.uuid, 'lastname', $event.target.value)"
                  />
                </div>
              </div>
          </div>
        </div>

        <div class="form-row">
          <div class="annotations">
            <mat-label class="annotations-label">{{
              "hotel.custom.annotations" | translate
            }}</mat-label>
            <textarea
              class="annotation-textarea form-control form-control--no-border"
              formControlName="comments"
              placeholder="{{
                'hotel.custom.annotations-placeholder' | translate
              }}"
            ></textarea>
          </div>
        </div>

        <div class="button-row">
          <button
            [ngStyle]="{
              cursor: !form.valid || loading || !isFormValid() ? 'not-allowed' : 'pointer'
            }"
            [ngClass]="{
              'custom-btn disabled-button': !form.valid || loading || !isFormValid(), 'custom-btn': form.valid || !loading
            }"
            [disabled]="!form.valid || !isFormValid() || loading"
          >
            {{ "common.send-request" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
